import { render, staticRenderFns } from "./MessageItemLink.vue?vue&type=template&id=16a6e74e&"
import script from "./MessageItemLink.vue?vue&type=script&lang=ts&"
export * from "./MessageItemLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports